import React, { useMemo } from "react";

import Sidebar from "../Sidebar";
import Header from "../Header";
import StudentDashboard from "./StudentDashboard";
import NewMessagePopup from "../NewMessagePopup";
import { useAuth } from "../../context/AuthContext";
import { filterLinksByPermissions } from "../../config/permissions";

const allStudentLinks = [
  { to: "/student/home", label: "Home", feature: "home" },
  {
    to: "/student/grading",
    label: "Grading",
    feature: "grading",
    children: [
      { to: "/student/grades", label: "My Grades", feature: "viewData" },
      { to: "/student/subjects", label: "Subjects", feature: "viewData" },
    ],
  },
  {
    to: "/student/action",
    label: "Action",
    feature: "action",
    children: [
      { to: "/student/assignments", label: "Assignments", feature: "action" },
      { to: "/student/work-gallery", label: "My Work Gallery", feature: "action" },
      { to: "/student/todo", label: "Student Goals (Coming soon)", feature: "goals" },
      { to: "/student/feedback", label: "Feedback", feature: "viewData" },
      { to: "/student/requests", label: "Requests", feature: "changeRequests" },
    ],
  },
  { to: "/student/connect", label: "Connect", feature: "connect" },
  {
    to: "/student/help-support",
    label: "Help",
    feature: "helpSupport",
    children: [
      { to: "/student/surveys", label: "Surveys (Coming soon)", feature: "helpSupport" },
    ],
  },
];

const StudentLayout = () => {
  const { user } = useAuth();
  const userRoles = useMemo(() => user?.roles || user?.role || [], [user?.roles, user?.role]);
  
  const studentLinks = useMemo(
    () => filterLinksByPermissions(allStudentLinks, userRoles),
    [userRoles]
  );

  return (
    <div className="ae-shell">
      <Sidebar links={studentLinks} />
      <div className="ae-shell-content">
        <Header />
        <main className="ae-shell-main">
          <StudentDashboard />
        </main>
      </div>
      <NewMessagePopup defaultRole="student" />
    </div>
  );
};

export default StudentLayout;
